import BaseQuizGame from "./BaseQuizGame.js";
import { renderFlagDuelError } from "../utils/FlagUtils.js";
import { readZone, scopedGameId, renderZoneBar } from "../utils/ZoneScope.js";

export default class FlagNerdClassic extends BaseQuizGame {
	constructor() {
		const zone = readZone();
		super(scopedGameId('flagnerd', zone), '.flag-nerd-classic', {
			passportStamp: "flag",
			gameNameKey: "home.flagNerd",
			modeLabelKey: "home.classic",
			mode: "classic",
			shareEmoji: "🟦",
			slug: zone ? `flag-nerd-classic?zone=${zone}` : "flag-nerd-classic",
			zoneKey: zone ? `mapExploration.continents.${zone}` : null
		});
		if (!this.page) return;
		this.zone = zone;
		renderZoneBar(this.page, zone);

		this.init();
	}

	renderErrorItem(error) {
		return renderFlagDuelError(error);
	}
}
